'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = mcuStore;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
    return arr2;
  } else {
    return Array.from(arr);
  }
}
var _redux = require('redux');
var _reduxThunk = require('redux-thunk');
var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
var _reducersMcu = require('../reducers/mcu');
var _reducersMcu2 = _interopRequireDefault(_reducersMcu);
var _reducersVideoRoom = require('../reducers/videoRoom');
var _reducersVideoRoom2 = _interopRequireDefault(_reducersVideoRoom);
function mcuStore() {
  var reducers = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
  var middlewares = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
  var createStoreWithMiddleware = _redux.applyMiddleware.apply(undefined, [_reduxThunk2['default']].concat(_toConsumableArray(middlewares)))(_redux.createStore);
  var reducer = (0, _redux.combineReducers)(Object.assign.apply(Object, [{}, _reducersMcu2['default'], _reducersVideoRoom2['default']].concat(_toConsumableArray(reducers))));
  return createStoreWithMiddleware(reducer);
}
module.exports = exports['default'];